module.exports = __webpack_public_path__ + "img/pc_p2_yunying.f93d1cbd.png";